document.addEventListener('DOMContentLoaded', () => {

  async function getCart() {
    try {
      const res = await fetch('/cart.js');
      const data = await res.json();
      return data;
    } catch (err) {
      return null;
    }
  }

  async function isProtectedLogo(logoUrl) {
    const cart = await getCart();
    if (!cart?.items?.length) {
      return false;
    }

    const logo = (logoUrl || '').trim();
    if (!logo) {
      return false;
    }

    const currentLogos = cart.items
      .map(i => (i.properties?.['Current Logo'] || '').trim())
      .filter(Boolean);


    const found = currentLogos.some(cur =>
      cur && (cur === logo || cur.includes(logo) || logo.includes(cur))
    );
    return found;
  }

  function setupCustomButtons() {
    const allButtons = document.querySelectorAll('cart-remove-button');

    allButtons.forEach((cartBtn, index) => {

      if (cartBtn.dataset.customised === 'true') {
        return;
      }
      cartBtn.dataset.customised = 'true';

      const originalTrigger =
        cartBtn.querySelector('a[href*="/cart/change"]') ||
        cartBtn.querySelector('button.cart-remove-button');
      if (!originalTrigger) {
        return;
      }

      const row = cartBtn.closest('.cart-item');
      if (!row) {
        return;
      }

      // 🔍 Collect all property labels (dt/dd pairs) for this item first
      const props = {};
      row.querySelectorAll('dt').forEach(dt => {
        const key = dt.textContent.trim();
        const value = dt.nextElementSibling?.textContent?.trim() || '';
        props[key] = value;
      });

      // ✅ Now detect if this is a "Logo" item (not "Current" or "Past")
      const isLogoItem = Object.keys(props).some(k => {
        const name = k.trim().toLowerCase();
        return name.includes('logo') && !name.includes('current') && !name.includes('past');
      });

      // ✅ Extract the logo URL only if the label text matches that rule
      let logoUrl = null;
      if (isLogoItem) {
        row.querySelectorAll('dt').forEach(dt => {
          const label = dt.textContent.trim().toLowerCase();
          // console.log("label:", label);
          if (label.includes('logo') && !label.includes('current') && !label.includes('past')) {
            // console.log("present label:", label);
            const link = dt.nextElementSibling?.querySelector('a[href]');
            // console.log("link:", link);
            if (link) logoUrl = link.href;
          }
        });
      }

      if (!logoUrl) {
        // return;
      }

      cartBtn.style.display = 'none';

      const newBtn = document.createElement('button');
      newBtn.type = 'button';
      newBtn.className = 'button button--tertiary custom-remove-btn';
      newBtn.style.marginLeft = '6px';
      newBtn.style.cursor = 'pointer';
      // newBtn.textContent = 'Remove';
      newBtn.innerHTML = `
        <span class="svg-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-remove" viewBox="0 0 16 16"><path fill="currentColor" d="M14 3h-3.53a3.07 3.07 0 0 0-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 0 0 5.53 3H2a.5.5 0 0 0 0 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 0 0 .5-.5V4H14a.5.5 0 0 0 0-1M6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02m4.84 11.52h-7.5V4h7.5z"></path><path fill="currentColor" d="M6.55 5.25a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5m2.9 0a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5"></path></svg>
        </span>
      `;

      try {
        if (cartBtn.parentNode && cartBtn.parentNode.nodeType === 1) {
          cartBtn.parentNode.insertBefore(newBtn, cartBtn.nextSibling);
        } else {
          const row = cartBtn.closest('.cart-item');
          row.appendChild(newBtn);
        }
      } catch (err) {
        const row = cartBtn.closest('.cart-item');
        if (row) row.appendChild(newBtn);
      }

      newBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();

        const blocked = await isProtectedLogo(logoUrl);
        if (blocked) {
          showInlineError(row, '⚠️ This item cannot be removed because its logo is currently in use.');
          return;
        }
        originalTrigger.click();
      });
    });
  }

  function showInlineError(container, message) {
    // Remove any existing popup first
    const existing = document.querySelector('.custom-remove-popup');
    if (existing) existing.remove();

    // Create popup element
    const popup = document.createElement('div');
    popup.className = 'custom-remove-popup';
    popup.textContent = message;

    // Style the popup (centre of screen)
    Object.assign(popup.style, {
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      background: 'rgba(0, 0, 0, 0.85)',
      color: '#fff',
      padding: '10px 20px',
      borderRadius: '6px',
      fontSize: '14px',
      fontWeight: '500',
      zIndex: '9999',
      textAlign: 'center',
      opacity: '1',
      transition: 'opacity 0.4s ease'
    });

    // Add to body
    document.body.appendChild(popup);

    // Auto-fade after 2.5s, then remove at 3s
    setTimeout(() => (popup.style.opacity = '0'), 2500);
    setTimeout(() => popup.remove(), 3000);
  }

  setupCustomButtons();

  const observer = new MutationObserver(() => {
    setupCustomButtons();
  });
  observer.observe(document.body, { childList: true, subtree: true });
});





























// console.log('🧩 Debug: embroidery cart-logo refresher loaded');

function reloadCurrentLogos() {
  // console.log('🌀 reloadCurrentLogos() CALLED (fetching from /cart.js)');

  fetch('/cart.js')
    .then(res => {
      // console.log('📡 /cart.js response status:', res.status);
      return res.json();
    })
    .then(cart => {
      // console.log('🛒 Cart data received:', cart);

      const existingWrapper = document.querySelector('#current-logo-wrapper');
      if (!existingWrapper) {
        console.warn('⚠️ #current-logo-wrapper not found on page.');
        return;
      }

      // Collect logo URLs from all cart items
      let logoUrls = [];
      cart.items.forEach(item => {
        if (item.properties && item.properties['Logo']) {
          const cleaned = item.properties['Logo']
            .replace(/[\[\]" ]/g, '')
            .split(',')
            .filter(url => url.startsWith('http'));
          logoUrls.push(...cleaned);
        }
      });

      // Remove duplicates
      logoUrls = [...new Set(logoUrls)];
      // console.log('🧩 Extracted logo URLs:', logoUrls);

      // Rebuild the HTML for the Current Logo section
      if (logoUrls.length === 0) {
        existingWrapper.innerHTML = `
          <div class="wrap-currentlogo">
            <div class="title_logo_past">Current Logo</div>
            <p>No current logos found.</p>
          </div>`;
        // console.log('ℹ️ No logos in cart. Section cleared.');
        return;
      }

      const html = `
        <div class="wrap-currentlogo">
          <div class="title_logo_past">Current Logo</div>
          <div class="logo_current_c3">
            ${logoUrls.map((url, i) => `
              <div class="option">
                <label for="currentlogo_${i + 1}" class="freelabel reallogo_current" data-price="0">
                  <input type="radio" style="opacity:0;" name="properties[Current Logo]" 
                    class="fix_current" id="currentlogo_${i + 1}" value="${url}">
                  <img src="${url}" width="65" height="65" alt="Current Logo">
                </label>
              </div>
            `).join('')}
          </div>
        </div>`;
      
      existingWrapper.innerHTML = html;
      // console.log('✅ Current logos refreshed successfully.');
    })
    .catch(err => console.error('❌ Error fetching /cart.js:', err));
}


// ------------------------------------------------------------
// 📦 EVENT HANDLERS — detect cart changes anywhere
// ------------------------------------------------------------
document.addEventListener('DOMContentLoaded', () => {
  // console.log('✅ DOM ready — attaching cart change listeners');

  // Initial check on page load
  setTimeout(() => {
    // console.log('🧪 Initial test: calling reloadCurrentLogos()');
    reloadCurrentLogos();
  }, 1500);

  // --- Listen for Shopify AJAX calls (fetch)
  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const [url] = args;
    const isCartAction =
      typeof url === 'string' &&
      (url.includes('/cart/add') || url.includes('/cart/update') || url.includes('/cart/change'));

    if (isCartAction) {
      // console.log('🧲 Intercepted Shopify fetch →', url);
    }

    const response = await originalFetch(...args);

    if (isCartAction) {
      // console.log('🧩 Cart update detected via fetch → refreshing logos...');
      setTimeout(reloadCurrentLogos, 1200);
    }

    return response;
  };

  // --- Listen for older XHR requests
  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (...args) {
    const [method, url] = args;
    if (url && (url.includes('/cart/add') || url.includes('/cart/update') || url.includes('/cart/change'))) {
      // console.log('📦 XHR cart request intercepted:', url);
      this.addEventListener('load', () => {
        // console.log('📬 XHR cart response received — refreshing logos...');
        setTimeout(reloadCurrentLogos, 1200);
      });
    }
    origOpen.apply(this, args);
  };

  // --- Fallback for manual remove / update buttons
  document.addEventListener('click', (e) => {
    if (e.target.matches('.cart__remove') || e.target.matches('[name="update"]')) {
      // console.log('🧨 Manual cart action detected — refreshing logos...');
      setTimeout(reloadCurrentLogos, 1500);
    }
  });
});